import { handleActions } from 'redux-actions';
import { defaultMutedTagsWidgetState } from './defaults';
import { MutedTagsWidgetData } from './types';
import { initBrowsingPage } from '../../actions';
import {
  makeSpecificSaveableWidgetDataMergeFunction,
  saveRequestMetaReducer,
} from '../utils';
import {
  setMutedTagsWidgetBlacklistedTags,
  saveMutedTags,
  saveMutedTagsSuccess,
  saveMutedTagsFailure,
} from './actions';
import { NetworkRequestState } from '../baseTypes';

const mergeMutedTagsWidgetDataChange =
  makeSpecificSaveableWidgetDataMergeFunction(defaultMutedTagsWidgetState);

export default handleActions<MutedTagsWidgetData, any>(
  {
    [initBrowsingPage.toString()]: (
      state,
      action: ReturnType<typeof initBrowsingPage>
    ) => {
      const data: MutedTagsWidgetData['initialData'] = {
        blacklistedTags: action.payload.data.blacklistedTags ?? [],
      };
      return {
        initialData: data,
        currentData: data,
        isDirty: false,
        saveRequest: {
          status: NetworkRequestState.IDLE,
        },
      };
    },
    [setMutedTagsWidgetBlacklistedTags.toString()]: (
      state,
      action: ReturnType<typeof setMutedTagsWidgetBlacklistedTags>
    ) =>
      mergeMutedTagsWidgetDataChange(state, {
        blacklistedTags: action.payload.blacklistedTags,
      }),
    ...saveRequestMetaReducer({
      initialAction: saveMutedTags,
      successAction: saveMutedTagsSuccess,
      failureAction: saveMutedTagsFailure,
    }),
  },
  defaultMutedTagsWidgetState
);
